// extracted by mini-css-extract-plugin
export default {"modal":"W0-z","overlay":"X0-z","outfitSelector":"Y0-z","outfitHeading":"Z0-z","itemContainer":"_0-z","item":"a1-z","selected":"b1-z"};